import { AnimationBuilder, AnimationPlayer, animate, style } from '@angular/animations';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-generic-step-header',
  templateUrl: './generic-step-header.component.html',
  styleUrls: ['./generic-step-header.component.scss'],
})
export class GenericStepHeaderComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() currentStep: number;
  @Input() previousStep: number;
  @Input() steps: number;
  @Output() backClick = new EventEmitter<any>();
  @Output() additionalIconClick = new EventEmitter<any>();
  @Input() additionalIcon: string;
  @Input() additionalIconLabel: string;

  @ViewChild('loadingBar', {
    read: ElementRef,
    static: true,
  })
  loadingBar: ElementRef;
  @ViewChild('backButton', {
    read: ElementRef,
    static: true,
  })
  backButton: ElementRef;

  constructor(private readonly builder: AnimationBuilder) {}

  ngOnInit(): void {
    this.updateProgressBar();
  }

  ngOnChanges() {
    this.updateProgressBar();
  }

  updateProgressBar() {
    if (this.currentStep > this.steps) {
      this.currentStep = this.steps;
    }

    if (this.previousStep === this.currentStep) {
      return;
    }

    if (!this.loadingBar) {
      return;
    }

    const factoryIncrement = this.builder.build([
      style({ width: `${this.getInitialProgressValue(this.currentStep)}%` }),
      animate(
        '400ms 0ms ease-out',
        style({
          width: `${this.getFinalProgressValue(this.currentStep)}%`,
        }),
      ),
    ]);

    const factoryDecrement = this.builder.build([
      style({ width: `${this.getFinalProgressValue(this.previousStep)}%` }),
      animate(
        '400ms 0ms ease-out',
        style({
          width: `${this.getFinalProgressValue(this.currentStep)}%`,
        }),
      ),
    ]);

    let player: AnimationPlayer;
    if (this.previousStep <= this.currentStep) {
      player = factoryIncrement?.create(this.loadingBar.nativeElement, {});
    } else {
      player = factoryDecrement?.create(this.loadingBar.nativeElement, {});
    }

    this.previousStep = this.currentStep;
    player?.play();
  }

  private getInitialProgressValue(step: number): number {
    return ((step - 1) * 100) / this.steps;
  }

  private getFinalProgressValue(step: number): number {
    return (step * 100) / this.steps;
  }
}
